<template>
  <div>
    <v-progress-linear
      v-show="progressBar"
      slot="progress"
      color="blue"
      indeterminate
    />
    <br />
    <span v-bind:title="msgAlert">
      <Alert
        :status="status"
        :msg="msgAlert"
        id="alertWarning"
      />
      <p>Eleição: {{$store.state.vote.electionName}}</p>
      <p>Documento: {{$store.state.vote.identifier}}</p>
      <p>Nome: {{$store.state.vote.name}}</p>
      <p>Data: {{$store.state.vote.votedOn}}</p>
    </span>
    <br />
    <br />
    <div
      class="col-1"
      v-if="bHidden"
    >
      <!-- <v-btn
        @click="printPage"
        tile
        block
        type="btn"
        class="blue-box white-text"
      >
        Imprimir
      </v-btn> -->
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  components: {
    Alert: () => import('@/components/Alert')
  },
  data: () => ({
    status: '',
    msgAlert: '',
    progressBar: true,
    nameElection: '',
    bHidden: true,
    TimerEnd: {
      bFlagActivateTimer: false,
      value: null
    }
  }),
  watch: {
    nameElection(value) {
      if (value !== '') this.progressBar = false;
    }
  },
  mounted() {
    this.getVote();
    this.msgAlert = 'Você já votou';
    this.status = 'warning';
  },
  methods: {
    ...mapActions('vote', { get: 'get' }),
    async getVote() {
      await this.get({
        idElection: this.$store.state.login.election
      }).then(() => {
        this.nameElection = this.$store.state.vote.electionName;
        this.TimerEnd.bFlagActivateTimer = this.$store.state.election.receiptTime;
        this.TimerEnd.value = this.$store.state.election.receiptTimeValue;
        if (this.TimerEnd.bFlagActivateTimer) {
          setTimeout(() => {
            this.$store.state.logout();
          }, this.TimerEnd.value);
        }
      });
    },
    printPage() {
      this.bHidden = false;
      window.print();
      this.bHidden = true;
    }
  }
};
</script>
<style>
.v-application--wrap {
  min-height: 100vh !important;
}
</style>
